import creativeBuilderTpl from '../templates/ad_builder/creative_builder.html';

export default function creativeBuilder() {
  return {
    restrict: 'E',
    template: creativeBuilderTpl,
    controller: 'CreativeBuilderController',
    controllerAs: 'buildVm',
    bindToController: true,
    scope: {
      partner: '='
    }
  };
}
